// Google map

import '../../components/facility/map-marker-euc.svg'

const googleMapsKey = 'AIzaSyCtVLV2yHdQ_4Z79oUXVlN7GkrGNvqnDaQ';
const googleMapConfig = {
    center: { lat: 49.7437572, lng: 15.3386383 },
    zoom: 7,
}
const defaultGooleMapZoom = 16;

var gMap;
var gMarkerList;
var gMarkerCluster;

class Map {
    static createMapMarker() {
        if (gMarkerData.length > 1) {
            var latlngbounds = new google.maps.LatLngBounds();
            gMarkerData.forEach(function (marker) {
                latlngbounds.extend(marker.latLng);
            });
            var mapConfig = {
                center: latlngbounds.getCenter(),
                zoom: defaultGooleMapZoom,
            }
            gMap = new google.maps.Map(gMapElement, mapConfig);
            gMap.fitBounds(latlngbounds);
        } else if (gMarkerData.length > 0) {
            var mapConfig = {
                center: gMarkerData[0].latLng,
                zoom: defaultGooleMapZoom,
            }
            gMap = new google.maps.Map(gMapElement, mapConfig);
        }
        else {
            gMap = new google.maps.Map(gMapElement, googleMapConfig);
        }

        gMarkerList = [];
        gMarkerData.forEach(function (markerItem) {
            var marker = new google.maps.Marker({
                position: markerItem.latLng,
                icon: {
                    labelOrigin: new google.maps.Point(16, 48),
                    url: markerItem.pin,
                    scaledSize: new google.maps.Size(32, 32),
                },
                optimized: false,
                title: markerItem.title,
                localities: markerItem.localities,
                facilityTypes: markerItem.facilityTypes,
            });
            marker.setMap(gMap);
            google.maps.event.addListener(marker, 'click', (function (marker, markerItem) {
                return function () {
                    var $container = $('#mapPlacesCollapse');
                    $container.addClass("show");
                    $container.animate({ scrollTop: $container.scrollTop() + $("#card" + markerItem.id).position().top }, '500');
                };
            })(marker, markerItem));
            gMarkerList.push(marker);
        });

        gMarkerCluster = new MarkerClusterer(gMap, [], { imagePath: '/images/m4.png' });
        filterMarkers();
        filterCards();
        filterLists();
        return gMap;
    }
}

function initMapFacilities() {
    console.log('initMapFacilities');
    console.log(gMarkerData);
    Map.createMapMarker();
}
window.initMapFacilities = initMapFacilities;

function placeMarkers(inputData, pinUrl) {
    window.gMarkerData = [];
    inputData.forEach(function (model) {
        var marker = {
            latLng: { lat: model.Latitude, lng: model.Longitude },
            title: model.Name,
            id: model.Id,
            pin: pinUrl,
            localities: model.LocalityList,
            facilityTypes: [],
        }
        model.FacilityList.forEach(function (facility) {
            marker.facilityTypes.push(facility.FacilityType);
        });
        gMarkerData.push(marker);
    });
    console.log(gMarkerData);

    var js_file = document.createElement('script');
    js_file.type = 'text/javascript';
    js_file.src = 'https://maps.googleapis.com/maps/api/js?callback=initMapFacilities&key=' + googleMapsKey;
    document.getElementsByTagName('head')[0].appendChild(js_file);
}

function filterMarkers() {
    console.log('filterMarkers');

    var isClinics = $('#facilitiesFilterClinic').is(':checked');
    var isMamocenters = $('#facilitiesFilterMamocenter').is(':checked');
    var isPharmacies = $('#facilitiesFilterPharmacy').is(':checked');
    var isLaboratories = $('#facilitiesFilterLaboratory').is(':checked');
    var locality = $('#facilitiesFilterLocality').val();

    var visibleMarkers = [];
    gMarkerList.forEach(function (marker) {
        var isVisible = false;
        if (isClinics && marker.facilityTypes.includes("Clinic")) {
            isVisible = true;
        }
        if (isMamocenters && marker.facilityTypes.includes("Mamocenter")) {
            isVisible = true;
        }
        if (isPharmacies && marker.facilityTypes.includes("Pharmacy")) {
            isVisible = true;
        }
        if (isLaboratories && marker.facilityTypes.includes("Laboratory")) {
            isVisible = true;
        }
        if (locality.length > 0) {
            if (!marker.localities.includes(locality)) {
                isVisible = false;
            }
        }
        if (isVisible) {
            visibleMarkers.push(marker);
        }
        marker.setVisible(isVisible);
    });
    gMarkerCluster.clearMarkers();
    gMarkerCluster.addMarkers(visibleMarkers);

    if (visibleMarkers.length > 1) {
        var latlngbounds = new google.maps.LatLngBounds();
        visibleMarkers.forEach(function (marker) {
            latlngbounds.extend(marker.position);
        });
        gMap.fitBounds(latlngbounds);
    } else if (visibleMarkers.length > 0) {
        gMap.panTo(visibleMarkers[0].position);
        gMap.setZoom(10);
    }
    else {
        gMap.panTo(googleMapConfig.center);
        gMap.setZoom(googleMapConfig.zoom);
    }
}

function filterCards() {
    var isClinics = $('#facilitiesFilterClinic').is(':checked');
    var isMamocenters = $('#facilitiesFilterMamocenter').is(':checked');
    var isPharmacies = $('#facilitiesFilterPharmacy').is(':checked');
    var isLaboratories = $('#facilitiesFilterLaboratory').is(':checked');
    var locality = $('#facilitiesFilterLocality').val();

    $('.Building-Card').each(function () {
        var $card = $(this);
        var isVisible = false;
        var facilityTypes = ($card.data('facility-types') + '').split(',');
        if (isClinics && facilityTypes.includes("Clinic")) {
            isVisible = true;
        }
        if (isMamocenters && facilityTypes.includes("Mamocenter")) {
            isVisible = true;
        }
        if (isPharmacies && facilityTypes.includes("Pharmacy")) {
            isVisible = true;
        }
        if (isLaboratories && facilityTypes.includes("Laboratory")) {
            isVisible = true;
        }
        if (locality.length > 0) {
            var localities = ($card.data('localities') + '').split(',');
            if (!localities.includes(locality)) {
                isVisible = false;
            }
        }
        if (isVisible) {
            $card.show();
        } else {
            $card.hide();
        }
        var isActive = false;
        $card.find('.nav-item').each(function () {
            var $tab = $(this);
            var facilityType = $tab.data('facility-type');
            var tabVisible = false;
            if (isClinics && facilityType == "Clinic") {
                tabVisible = true;
            }
            if (isMamocenters && facilityType == "Mamocenter") {
                tabVisible = true;
            }
            if (isPharmacies && facilityType == "Pharmacy") {
                tabVisible = true;
            }
            if (isLaboratories && facilityType == "Laboratory") {
                tabVisible = true;
            }
            if (tabVisible) {
                if (!isActive) {
                    $tab.find('a').click();
                    isActive = true;
                }
                $tab.removeClass('d-none').addClass('d-flex');
            } else {
                $tab.addClass('d-none').removeClass('d-flex');
            }
        });
    });
}

function filterLists() {
    var isClinics = $('#facilitiesFilterClinic').is(':checked');
    var isMamocenters = $('#facilitiesFilterMamocenter').is(':checked');
    var isPharmacies = $('#facilitiesFilterPharmacy').is(':checked');
    var isLaboratories = $('#facilitiesFilterLaboratory').is(':checked');
    var locality = $('#facilitiesFilterLocality').val();

    $('.Facility-Type').each(function () {
        var $column = $(this);
        var isVisible = false;
        var facilityType = $column.data('facility-type');
        if (isClinics && facilityType == "Clinic") {
            isVisible = true;
        }
        if (isMamocenters && facilityType == "Mamocenter") {
            isVisible = true;
        }
        if (isPharmacies && facilityType == "Pharmacy") {
            isVisible = true;
        }
        if (isLaboratories && facilityType == "Laboratory") {
            isVisible = true;
        }
        if (isVisible) {
            $column.show();
        } else {
            $column.hide();
        }
    });
    $('.Facility-Item').each(function () {
        var isVisible = true;
        var $facilityItem = $(this);
        if (locality.length > 0) {
            var localities = ($facilityItem.data('localities') + '').split(',');
            if (!localities.includes(locality)) {
                isVisible = false;
            }
        }
        if (isVisible) {
            $facilityItem.addClass('d-block').show();
        } else {
            $facilityItem.removeClass('d-block').hide();
        }
    });
}

$(function () {
    $('.jsFacilities-Filter').on('change', function () {
        filterMarkers();
        filterCards();
        filterLists();
    });
});

function httpGetAsync(pinUrl, url, callback) {
    $.get(url, function (data) {
        callback(data, pinUrl);
    });
}

const addGoogleMapFacilities = function (mapSelector) {
    document.addEventListener('DOMContentLoaded', function () {
        var mapElement = document.querySelector(mapSelector);
        if (mapElement) {
            window.gMapElement = mapElement;
            var url = gMapElement.getAttribute("data-url");
            var pin = gMapElement.getAttribute("data-pin");
            console.log(pin);
            httpGetAsync(pin, url, placeMarkers);
        }
    });
}

export default addGoogleMapFacilities;
